app.service("CacheLocalServerService", ['$rootScope', '$http', function ($rootScope, $http) {

    const service = this;

    const siteHelper = $rootScope.site_helper;

    this.cache_initialized = false;
    this.cache_ready = false;

    let haveValidBrowseContent = false;
    let haveProductDocuments = false;
    const productDocumentsCallbacks = [];

    const onInitializedListeners = [];
    const onReadyListeners = [];

    const CacheLocalServerModel = function () {
        this.is_local_admin_available = false;
        this.site_range = {};
        this.colour = {
            site_range: {}
        };
        this.style = {
            site_range: {}
        };
        this.component = {
            panel: {},
            door: {},
            frame: {},
            curved: {},
            solution: {},
            stock: {},
            wrap: {}
        }
        this.base_colour = {
            choices: {},
            choice_order: [],
        }
        this.finish_option = {
            choices: {},
            choice_order: [],
        }
        this.manufacturing_process = {
            choices: {},
            choice_order: [],
        }
        this.base_style = {
            choices: {},
            choice_order: [],
        }
        this.express_24_option = {
            choices: {},
            choice_order: [],
        }
        this.m2m_option = {
            choices: {},
            choice_order: [],
        }
        this.local_image = {};
        this.holidays = [];
        this.marketing_asset = {};
        this.product_document = [];
    }

    this.model = new CacheLocalServerModel();

    function handleBrowseContent(cacheAcquiredChoice) {
        const model = service.model;

        for (let key in cacheAcquiredChoice) {
            const defaultEntry = model[key];
            const cacheEntry = cacheAcquiredChoice[key];
            if (defaultEntry && siteHelper.isObject(defaultEntry) && siteHelper.keyCount(defaultEntry) && siteHelper.isObject(cacheEntry)) {
                for (let defaultEntryKey in defaultEntry) {
                    if (!cacheEntry[defaultEntryKey]) {
                        cacheEntry[defaultEntryKey] = defaultEntry;
                    }
                }
            }
            if (!customizedParse(key, cacheEntry)) {
                model[key] = cacheEntry;
            }
        }

        const maxSortIndex = Number.MAX_SAFE_INTEGER;
        for (let siteRangeID in model.colour.site_range) {
            if (!model.colour.site_range[siteRangeID].choices) {
                model.colour.site_range[siteRangeID].choices = {}
            }
            const colours = model.colour.site_range[siteRangeID].choices;
            for (let colourID in colours) {
                const colour = colours[colourID];
                if (!colour.hasOwnProperty('sort_index')) {
                    colour.sort_index = maxSortIndex;
                }
            }
        }

        for (let siteRangeID in model.style.site_range) {
            if (!model.style.site_range[siteRangeID].choices) {
                model.style.site_range[siteRangeID].choices = {}
            }
            const styles = model.style.site_range[siteRangeID].choices;
            for (let styleID in styles) {
                const style = styles[styleID];
                if (!style.hasOwnProperty('sort_index')) {
                    style.sort_index = maxSortIndex;
                }
            }
        }

        normalizeComponent();
    }

    function getInitialContent() {
        const model = service.model;
        let haveBrowseContent = false;
        let haveLocalImage = false;

        function checkComplete() {

            if (!haveLocalImage || !haveBrowseContent) {
                return;
            }
            if (haveValidBrowseContent) {
                handleInitialized();
            }
            getAdditionalContent();
        }

        function getBrowseContent() {

            $http({
                url: '/request/cache-request.php?request_type=get_content&cache_id=acquired&create_if_empty=1',
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(function (response) {
                    haveBrowseContent = true;
                    const cacheAcquiredChoice = response.data;
                    haveValidBrowseContent = !!cacheAcquiredChoice && siteHelper.keyCount(cacheAcquiredChoice) > 0;
                    if (haveValidBrowseContent) {
                        handleBrowseContent(cacheAcquiredChoice);
                    } else {
                        console.warn("Invalid Cache [2]")
                    }
                    checkComplete();
                }, function (response) {
                    haveBrowseContent = true;
                    console.warn("Invalid Cache [1]")
                    checkComplete();
                });
        }

        function getLocalImage() {
            $http({
                url: '/request/cache-request.php?request_type=get_content&cache_id=image_info',
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(function (response) {
                    model.local_image = response.data;
                    haveLocalImage = true;
                    checkComplete();
                }, function (response) {
                    haveLocalImage = true;
                    checkComplete();
                });
        }

        getBrowseContent();
        getLocalImage();
    }

    function getAdditionalContent() {
        const model = service.model;

        let haveHolidays = false;
        let haveMarketingAsset = false;

        //todo. It looks like the site pauses until this process completes. Ideally I would not have this happen

        function checkCacheUpdate() {

            //We send out a request to cache-request.php to see if it needs to update itself.

            //If it does then any changes it determines will be available for the next user or when this user refreshes their page


            $http({
                url: '/request/cache-request.php?request_type=init_silent_sync&cache_id=all_cache',
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            })

        }

        function checkComplete() {

            if (!haveHolidays || !haveProductDocuments || !haveMarketingAsset) {
                return;
            }
            console.log("CacheLocalServerModel")
            console.log(model)
            handleReady();
            checkCacheUpdate();
        }

        $http({
            url: '/request/cache-request.php?request_type=get_content&cache_id=holiday',
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                const holidays = response.data;
                for (let i = 0; i < holidays.length; i++) {
                    const holiday = holidays[i];
                    holiday.tags = holiday.tags ? holiday.tags : [];
                    const starts = holiday.starts;
                    const ends = holiday.ends;
                    if (!starts || !ends) {
                        holidays.splice(i, 1);
                        i--;
                        continue;
                    }
                    holiday.starts = new Date(Date.parse(holiday.starts));
                    holiday.ends = new Date(Date.parse(holiday.ends));
                    holiday.starts.setHours(0, 0, 0, 0);
                    holiday.ends.setHours(0, 0, 0, 0);
                }
                model.holidays = holidays;
                haveHolidays = true;
                checkComplete();
            }, function (response) {
                haveHolidays = true;
                checkComplete();
            });
        $http({
            url: '/request/cache-request.php?request_type=get_content&cache_id=data&content_type=product_document',
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                model.product_document = response.data;
                haveProductDocuments = true;
                for (let i = 0; i < productDocumentsCallbacks.length; i++) {
                    productDocumentsCallbacks[i]();
                }
                productDocumentsCallbacks.length = 0;
                checkComplete();
            }, function (response) {
                haveProductDocuments = true;
                checkComplete();
            });
        $http({
            url: '/request/cache-request.php?request_type=get_content&cache_id=zip',
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                if (response.data && response.data.media && response.data.media.marketing_assets) {
                    model.marketing_asset = response.data.media.marketing_assets;
                }
                haveMarketingAsset = true;
                checkComplete();
            }, function (response) {
                haveMarketingAsset = true;
                checkComplete();
            });
    }

    service.productDocumentsByTags = function (tags, callback) {
        const model = service.model;

        function getProductDocumentsByTags() {
            const documents = [];
            for (let i = 0; i < model.product_document.length; i++) {
                const document = model.product_document[i];
                let haveAllTags = !!document.product_tags;
                if (haveAllTags) {
                    for (let j = 0; j < tags.length; j++) {
                        const tag = tags[j];
                        if (!document.product_tags[tag]) {
                            haveAllTags = false;
                            break;
                        }
                    }
                }
                if (haveAllTags) {
                    documents.push(document);
                }
            }

            if (callback) {
                callback(documents);
            }
            return documents;
        }

        if (haveProductDocuments) {
            return getProductDocumentsByTags();
        }
        productDocumentsCallbacks.push(getProductDocumentsByTags);
        return [];
    }

    service.applyPageVars = function () {

        if (typeof page_vars !== 'undefined' && page_vars) {

            if (page_vars.hasOwnProperty('is_local_admin_available')) {
                service.model.is_local_admin_available = !!page_vars.is_local_admin_available;
            }

            if (page_vars.user_role && page_vars.user_role.length) {
                $rootScope.model.account.user_role = page_vars.user_role;
            }
        }

    }

    function normalizeComponent() {
        const model = service.model;
        const siteRangeIDs = [];
        const requestRangeIDs = [];
        for (let siteRangeID in model.site_range.choices) {
            const siteRange = model.site_range.choices[siteRangeID];
            if (siteRange.disabled) {
                continue;
            }
            siteRangeIDs.push(siteRangeID);
            if (!requestRangeIDs.includes(siteRange.request_range_id)) {
                requestRangeIDs.push(siteRange.request_range_id);
            }
        }
        for (let componentID in model.component) {
            const component = model.component[componentID]
            if (!component.parent_category) {
                component.parent_category = {};
            }
            if (!component.parent_category_order) {
                component.parent_category_order = [];
            }
            if (!component.alpha_category) {
                component.alpha_category = {};
            }
            if (!component.alpha_category_order) {
                component.alpha_category_order = [];
            }
            for (let i = 0; i < component.parent_category_order.length; i++) {
                const id = component.parent_category_order[i];
                const parentCategory = component.parent_category[id];
                if (!parentCategory || component.parent_category_order.indexOf(id) < i) {
                    component.parent_category_order.splice(i, 1);
                    i--;
                }
            }
            for (let id in component.parent_category) {
                if (!component.parent_category_order.includes(id)) {
                    component.parent_category_order.push(id)
                }
            }
            for (let i = 0; i < component.alpha_category_order.length; i++) {
                const id = component.alpha_category_order[i];
                if (!component.alpha_category[id] || component.alpha_category_order.indexOf(id) < i) {
                    component.alpha_category_order.splice(i, 1);
                    i--;
                }
            }
            for (let id in component.alpha_category) {
                if (!component.alpha_category_order.includes(id)) {
                    component.alpha_category_order.push(id)
                }
            }
            normalizeComponentObject(component, requestRangeIDs, siteRangeIDs);
            for (let parentCategoryID in component.parent_category) {
                const parentCategory = component.parent_category[parentCategoryID];
                normalizeComponentObject(parentCategory, requestRangeIDs, siteRangeIDs);
                if (parentCategory.alpha_category) {
                    for (let alphaCategoryID in parentCategory.alpha_category) {
                        normalizeComponentObject(parentCategory.alpha_category[alphaCategoryID], requestRangeIDs, siteRangeIDs);
                    }
                }
            }
            if (component.products) {
                for (let productsID in component.products) {
                    normalizeComponentObject(component.products[productsID], requestRangeIDs, siteRangeIDs);
                }
            }
        }
    }

    function normalizeComponentObject(componentObject, requestRangeIDs, siteRangeIDs) {
        if (componentObject.hasOwnProperty('site_range') && !componentObject.site_range) {
            componentObject.site_range = {};
            for (let i = 0; i < siteRangeIDs.length; i++) {
                componentObject.site_range[siteRangeIDs[i]] = null;
            }
        }
        let hasBella = false;
        if (componentObject.site_range) {
            for (let siteRangeID in componentObject.site_range) {
                if (siteRangeID === "bella") {
                    hasBella = true;
                }
                if (!componentObject.site_range[siteRangeID]) {
                    componentObject.site_range[siteRangeID] = {};
                }
                const siteRangeObject = componentObject.site_range[siteRangeID];
                if (!siteRangeObject.style_exceptions) {
                    siteRangeObject.style_exceptions = [];
                }
                if (!siteRangeObject.colour_exceptions) {
                    siteRangeObject.colour_exceptions = [];
                }
            }
        }
        componentObject.requires_colour = !componentObject.no_colour_required;
        componentObject.requires_style = hasBella && !componentObject.no_style_required;
        delete componentObject.no_colour_required;
        delete componentObject.no_style_required;
    }

    function customizedParse(key, cacheEntry) {
        if (!["base_colour_list", "finish_option_list", "manufacturing_process_list", "base_style_list", "express_24_option_list", "m2m_option_list"].includes(key)) {
            return false;
        }
        const choices = {};
        const choiceOrder = [];
        for (let i = 0; i < cacheEntry.length; i++) {
            const choice = cacheEntry[i];
            const id = cacheEntry[i].id
            if (id && !choices[id]) {
                choices[id] = choice;
                choiceOrder.push(id);
            }
        }
        const model = service.model;
        const modelEntry = {
            choices: choices,
            choice_order: choiceOrder
        }
        switch (key) {
            case "base_colour_list":
                model.base_colour = modelEntry;
                break;
            case "finish_option_list":
                model.finish_option = modelEntry;
                break;
            case "manufacturing_process_list":
                model.manufacturing_process = modelEntry;
                break;
            case "base_style_list":
                model.base_style = modelEntry;
                break;
            case "express_24_option_list":
                model.express_24_option = modelEntry;
                break;
            case "m2m_option_list":
                model.m2m_option = modelEntry;
                break;
            default:
                break;
        }

        return true;
    }

    service.isComponentObjectAvailable = function (componentObject, siteRangeID, colourID, styleID) {
        if (!componentObject) {
            return false;
        }
        if (!siteRangeID || !componentObject.site_range || !siteHelper.keyCount(componentObject.site_range)) {
            return true;
        }
        const bySiteRange = componentObject.site_range[siteRangeID];
        if (!bySiteRange) {
            return false;
        }
        if (colourID && bySiteRange.colour_exceptions && bySiteRange.colour_exceptions.includes(colourID)) {
            return false;
        }
        if (styleID && bySiteRange.style_exceptions && bySiteRange.style_exceptions.includes(styleID)) {
            return false;
        }
        return true;
    }

    service.getParentCategoryGroupChoiceList = function (baseComponentID, parentCategoryGroupID) {
        if (!baseComponentID) {
            return [];
        }
        const cacheComponent = service.getComponentObject(baseComponentID);

        if (!cacheComponent) {
            return [];
        }
        const allParentCategoryGroups = cacheComponent.parent_category_group;
        const allParentCategoryGroupOrder = cacheComponent.parent_category_group_order;
        let parentCategoryGroupList = [];
        for (let i = 0; i < allParentCategoryGroupOrder.length; i++) {
            parentCategoryGroupList.push(allParentCategoryGroups[allParentCategoryGroupOrder[i]])
        }

        for (let i = 0; i < parentCategoryGroupList.length; i++) {
            const item = parentCategoryGroupList[i];
            if(parentCategoryGroupID && item.group_id !== parentCategoryGroupID){
                parentCategoryGroupList.splice(i, 1);
                i--;
            }
        }

        const choiceList = [];
        for (let i = 0; i < parentCategoryGroupList.length; i++) {
            const item = parentCategoryGroupList[i];
            const itemID = item.id;
            const choice = new $rootScope.model_constructor.RouteChoice({
                id: itemID,
                name: item.name,
                state_ids: {
                    base_component_id: baseComponentID,
                    parent_category_group_id: itemID
                },
                page_title: item.page_title ? item.page_title : "",
                public_id: item.public_id ? item.public_id : ""

            });
            choiceList.push(choice);
        }

        return choiceList;

    }

    service.getParentCategoryChoiceList = function (baseComponentID, choiceOrder, excludeChoiceOrder, parentCategoryGroupID, siteRangeID, colourID, styleID) {
        if (!baseComponentID) {
            return [];
        }
        const cacheComponent = service.getComponentObject(baseComponentID);

        if (!cacheComponent) {
            return [];
        }

        const allParentCategories = cacheComponent.parent_category;
        const allParentCategoryOrder = cacheComponent.parent_category_order;
        let parentCategoryList = [];
        for (let i = 0; i < allParentCategoryOrder.length; i++) {
            parentCategoryList.push(allParentCategories[allParentCategoryOrder[i]])
        }
        const parentCategoryGroup = parentCategoryGroupID ? (cacheComponent.parent_category_group ? cacheComponent.parent_category_group[parentCategoryGroupID] : null) : null;
        const parentCategoryGroupChildren = parentCategoryGroup?.children ?? [];

        for (let i = 0; i < parentCategoryList.length; i++) {
            const item = parentCategoryList[i];

            if(parentCategoryGroupID && !parentCategoryGroupChildren.includes(item.id)) {
                parentCategoryList.splice(i, 1);
                i--;
                continue;
            }
            if (!service.isComponentObjectAvailable(item, siteRangeID, colourID, styleID)) {
                parentCategoryList.splice(i, 1);
                i--;
            }
        }

        if (excludeChoiceOrder) {
            for (let i = 0; i < parentCategoryList.length; i++) {
                const item = parentCategoryList[i];
                if (excludeChoiceOrder.includes(item.id)) {
                    parentCategoryList.splice(i, 1);
                    i--;
                }
            }
        }

        if (choiceOrder) {
            const items = {};
            for (let i = 0; i < parentCategoryList.length; i++) {
                const item = parentCategoryList[i];
                items[item.id] = item;
            }
            parentCategoryList = []
            for (let i = 0; i < choiceOrder.length; i++) {
                if (choiceOrder.indexOf(choiceOrder[i]) < i) {
                    continue;
                }
                const item = items[choiceOrder[i]];
                if (item) {
                    parentCategoryList.push(item)
                }
            }
        }

        const choiceList = [];
        for (let i = 0; i < parentCategoryList.length; i++) {
            const item = parentCategoryList[i];
            const itemID = item.id;
            const choice = new $rootScope.model_constructor.RouteChoice({
                id: itemID,
                name: item.name,
                state_ids: {
                    base_component_id: baseComponentID,
                    parent_category_id: itemID
                },
                page_title: item.page_title ? item.page_title : "",
                public_id: item.public_id ? item.public_id : "",
                img_src: item.img_src ? item.img_src : "",
                limited_stock: !!item.limited_stock,
                requires_colour: !!item.requires_colour,
                requires_style: !!item.requires_style

            });
            choiceList.push(choice);
        }

        return choiceList;
    }

    service.getAlphaCategoryChoiceList = function (baseComponentID, parentCategoryGroupID, parentCategoryID, choiceOrder, excludeChoiceOrder, siteRangeID, colourID, styleID) {

        if (!baseComponentID) {
            return [];
        }
        const cacheComponent = service.getComponentObject(baseComponentID);
        if (!cacheComponent) {
            return [];
        }

        let cacheParentCategory = null;
        if (parentCategoryID) {
            cacheParentCategory = service.getComponentObject(baseComponentID, parentCategoryGroupID, parentCategoryID);
            if (!cacheParentCategory || !cacheParentCategory.alpha_category) {
                return [];
            }
        }

        const allAlphaCategories = cacheComponent.alpha_category;
        const allAlphaCategoryOrder = cacheComponent.alpha_category_order;
        let alphaCategoryList = [];
        for (let i = 0; i < allAlphaCategoryOrder.length; i++) {
            const id = allAlphaCategoryOrder[i]
            if (!cacheParentCategory || cacheParentCategory.alpha_category[id]) {
                const item = allAlphaCategories[id];
                alphaCategoryList.push(item)
            }
        }

        for (let i = 0; i < alphaCategoryList.length; i++) {
            const item = alphaCategoryList[i];
            if (!service.isComponentObjectAvailable(item, siteRangeID, colourID, styleID)) {
                alphaCategoryList.splice(i, 1);
                i--;
            }
        }

        if (excludeChoiceOrder) {
            for (let i = 0; i < alphaCategoryList.length; i++) {
                const item = alphaCategoryList[i];
                if (excludeChoiceOrder.includes(item.id)) {
                    alphaCategoryList.splice(i, 1);
                    i--;
                }
            }
        }

        if (choiceOrder) {
            const items = {};
            for (let i = 0; i < alphaCategoryList.length; i++) {
                const item = alphaCategoryList[i];
                items[item.id] = item;
            }
            alphaCategoryList = []
            for (let i = 0; i < choiceOrder.length; i++) {
                const item = items[choiceOrder[i]];
                if (item) {
                    alphaCategoryList.push(item)
                }
            }
        }
        const choiceList = [];
        for (let i = 0; i < alphaCategoryList.length; i++) {
            const item = alphaCategoryList[i];
            const itemID = item.id;
            let fromItem = item;
            const parentCategoryItem = cacheParentCategory && cacheParentCategory.alpha_category ? cacheParentCategory.alpha_category[itemID] : null;
            if (parentCategoryItem) {
                fromItem = siteHelper.simpleCloneObject(fromItem)
                fromItem = siteHelper.simpleCloneObject(parentCategoryItem, fromItem)
            }
            const choice = new $rootScope.model_constructor.RouteChoice({
                id: itemID,
                name: fromItem.name,
                state_ids: {
                    base_component_id: baseComponentID,
                    parent_category_group_id: fromItem.parent_category_group_id ? fromItem.parent_category_group_id : parentCategoryGroupID,
                    parent_category_id: fromItem.parent_category_id ? fromItem.parent_category_id : parentCategoryID,
                    alpha_category_id: itemID
                },
                page_title: fromItem.page_title ? fromItem.page_title : null,
                requires_colour: !!item.requires_colour,
                requires_style: !!item.requires_style,
                public_id: item.public_id

            });
            choiceList.push(choice);
        }
        return choiceList;
    }


    service.getBetaCategoryChoiceList = function (baseComponentID, parentCategoryGroupID, parentCategoryID, choiceOrder) {

        if (!baseComponentID) {
            return [];
        }
        const cacheComponent = service.getComponentObject(baseComponentID);
        if (!cacheComponent) {
            return [];
        }

        let cacheParentCategory = null;
        if (parentCategoryID) {
            cacheParentCategory = service.getComponentObject(baseComponentID, parentCategoryGroupID, parentCategoryID);
            if (!cacheParentCategory || !cacheParentCategory.alpha_category) {
                return [];
            }
        }

        const allBetaCategories = cacheComponent.beta_category;
        const allBetaCategoryOrder = cacheComponent.beta_category_order;
        if (!allBetaCategories || !allBetaCategoryOrder) {
            return [];
        }
        let betaCategoryList = [];
        for (let i = 0; i < allBetaCategoryOrder.length; i++) {
            const id = allBetaCategoryOrder[i]
            if (!cacheParentCategory || cacheParentCategory.beta_category[id]) {
                const item = allBetaCategories[id];
                betaCategoryList.push(item)
            }
        }

        if (choiceOrder) {
            const items = {};
            for (let i = 0; i < betaCategoryList.length; i++) {
                const item = betaCategoryList[i];
                items[item.id] = item;
            }
            betaCategoryList = []
            for (let i = 0; i < choiceOrder.length; i++) {
                const item = items[choiceOrder[i]];
                if (item) {
                    betaCategoryList.push(item)
                }
            }
        }
        const choiceList = [];
        for (let i = 0; i < betaCategoryList.length; i++) {
            const item = betaCategoryList[i];
            const itemID = item.id;
            let fromItem = item;
            const parentCategoryItem = cacheParentCategory && cacheParentCategory.beta_category ? cacheParentCategory.beta_category[itemID] : null;
            if (parentCategoryItem) {
                fromItem = siteHelper.simpleCloneObject(fromItem)
                fromItem = siteHelper.simpleCloneObject(parentCategoryItem, fromItem)
            }
            const choice = new $rootScope.model_constructor.ModelChoice({
                id: itemID,
                name: fromItem.name

            });
            choiceList.push(choice);
        }
        return choiceList;
    }


    service.isExcluded = function (baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID, productID, siteRangeID, styleID, colourID) {
        const validSiteRangeList = service.getValidSiteRangeIDs(
            baseComponentID,
            parentCategoryGroupID,
            parentCategoryID,
            alphaCategoryID,
            productID
        );
        if (!validSiteRangeList) {
            return false;
        }
        if (!validSiteRangeList.includes(siteRangeID)) {
            return true;
        }
        if (styleID) {
            const styleExceptions = service.getStyleExceptions(
                siteRangeID,
                baseComponentID,
                parentCategoryGroupID,
                parentCategoryID,
                alphaCategoryID,
                productID
            );
            if (styleExceptions.includes(styleID)) {
                return true;
            }
        }
        if (colourID) {
            const colourExceptions = service.getColourExceptions(
                siteRangeID,
                baseComponentID,
                parentCategoryGroupID,
                parentCategoryID,
                alphaCategoryID,
                productID
            );
            if (colourExceptions.includes(colourID)) {
                return true;
            }
        }
        return false;
    }


    service.getComponentProduct = function (baseComponentID, productID) {
        const componentCache = $rootScope.service.cache_local_server.getComponentObject(baseComponentID);
        const productCaches = componentCache ? componentCache.products : null;
        const productCache = productCaches ? productCaches[productID] : null;
        return productCache ? productCache : null;
    }

    service.getValidSiteRangeIDs = function (baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID, productID) {


        const productCache = $rootScope.service.cache_local_server.getComponentProduct(baseComponentID, productID);
        const choiceList = [];
        if (productCache && productCache.site_range) {
            for (let siteRangeID in productCache.site_range) {
                choiceList.push(siteRangeID);
            }
            return choiceList;
        }
        const componentObject = service.getAnySiteRangeComponentObject(baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID);
        if (!componentObject || !componentObject.site_range) {
            return null;
        }
        for (let siteRangeID in componentObject.site_range) {
            choiceList.push(siteRangeID);
        }
        return choiceList;
    }

    service.getStyleExceptions = function (siteRangeID, baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID, productID) {
        const productCache = $rootScope.service.cache_local_server.getComponentProduct(baseComponentID, productID);
        if (productCache && productCache.site_range) {
            const siteRange = productCache.site_range[siteRangeID];
            return siteRange && siteRange.style_exceptions ? siteRange.style_exceptions : [];
        }
        const componentObject = service.getAnySiteRangeComponentObject(baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID);
        if (!componentObject || !componentObject.site_range) {
            return [];
        }
        const siteRange = componentObject.site_range[siteRangeID];
        return siteRange && siteRange.style_exceptions ? siteRange.style_exceptions : [];
    }

    service.getColourExceptions = function (siteRangeID, baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID, productID) {
        const productCache = $rootScope.service.cache_local_server.getComponentProduct(baseComponentID, productID);
        if (productCache && productCache.site_range) {
            const siteRange = productCache.site_range[siteRangeID];
            return siteRange && siteRange.colour_exceptions ? siteRange.colour_exceptions : [];
        }
        const componentObject = service.getAnySiteRangeComponentObject(baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID);
        if (!componentObject || !componentObject.site_range || !componentObject.site_range[siteRangeID]) {
            return [];
        }
        const siteRange = componentObject.site_range[siteRangeID];
        return siteRange && siteRange.colour_exceptions ? siteRange.colour_exceptions : [];
    }


    service.getAnySiteRangeComponentObject = function (baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID) {
        let componentObject = service.getComponentObject(baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID);
        if (!componentObject || !componentObject.site_range) {
            if (alphaCategoryID) {
                componentObject = service.getComponentObject(baseComponentID, parentCategoryGroupID, parentCategoryID);
            }
            if (!componentObject || !componentObject.site_range) {
                if (parentCategoryID) {
                    componentObject = service.getComponentObject(baseComponentID);
                }
            }
        }
        return componentObject;
    }

    service.getComponentObject = function (baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID, alphaIsOptional, parentCategoryIsOptional) {
        const model = service.model;
        const component = baseComponentID ? model.component[baseComponentID] : null;
        if (!component) {
            return null;
        }
        if (!parentCategoryID) {
            return component;
        }
        const parentCategory = component.parent_category ? component.parent_category[parentCategoryID] : null;
        if (!parentCategory) {
            return parentCategoryIsOptional ? component : null;
        }
        if(parentCategoryGroupID){
            const parentCategoryGroup = component.parent_category_group ? component.parent_category_group[parentCategoryGroupID] : null;
            const children = parentCategoryGroup?.children ?? [];
            if(!children.includes(parentCategoryGroupID)) {
                return parentCategoryIsOptional ? component : null;
            }
        }
        if (!alphaCategoryID) {
            return parentCategory;
        }
        const alphaCategory = parentCategory.alpha_category ? parentCategory.alpha_category[alphaCategoryID] : null;
        return alphaCategory ? alphaCategory : (alphaIsOptional ? parentCategory : null);
    }

    function handleInitialized() {
        if (service.cache_initialized) {
            return
        }
        service.cache_initialized = true;
        for (let i = 0; i < onInitializedListeners.length; i++) {
            onInitializedListeners[i]();
        }
        onInitializedListeners.length = 0;
    }

    function handleReady() {
        if (service.cache_ready) {
            return
        }
        service.cache_ready = true;
        for (let i = 0; i < onReadyListeners.length; i++) {
            onReadyListeners[i]();
        }
        onReadyListeners.length = 0;
    }

    service.requireInitialized = function (callback) {
        if (service.cache_initialized) {
            callback();
            return;
        }
        onInitializedListeners.push(callback);
    }

    service.require_ready = function (callback) {
        if (service.cache_ready) {
            callback();
            return;
        }
        onReadyListeners.push(callback);
    }


    this.initCache = function () {
        getInitialContent();
    }

}])